// [hiperautomacao] The lead temperature is calculated by the instance
// database (schema-temperatura.sql). The screen only shows it, lets the
// seller register purchase signals and correct it with a reason.

export const TEMPERATURES = ["quente", "morno", "frio", "cliente"] as const;

export type Temperature = (typeof TEMPERATURES)[number];

// The seller corrects among these; "cliente" comes from a won deal.
export const CORRECTABLE_TEMPERATURES: readonly Temperature[] = [
  "quente",
  "morno",
  "frio",
];

export const MIN_REASON_LENGTH = 3;

interface TemperatureStyle {
  emoji: string;
  className: string;
}

export const TEMPERATURE_STYLE: Record<Temperature, TemperatureStyle> = {
  quente: {
    emoji: "🔥",
    className:
      "bg-red-100 text-red-800 border-red-200 dark:bg-red-950 dark:text-red-200 dark:border-red-900",
  },
  morno: {
    emoji: "🟡",
    className:
      "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950 dark:text-amber-200 dark:border-amber-900",
  },
  frio: {
    emoji: "🧊",
    className:
      "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-950 dark:text-sky-200 dark:border-sky-900",
  },
  cliente: {
    emoji: "⭐",
    className:
      "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-200 dark:border-emerald-900",
  },
};

export const isTemperature = (value: unknown): value is Temperature =>
  typeof value === "string" &&
  (TEMPERATURES as readonly string[]).includes(value);

export const isValidReason = (reason: string | null | undefined): boolean =>
  (reason ?? "").trim().length >= MIN_REASON_LENGTH;
